<template>
    <div style="width:100%">
        <v-dialog v-model="dialogDashboardChantier" fullscreen hide-overlay transition="dialog-bottom-transition" >
            <Loading :value="loading" ></Loading>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title >TABLEAU DE BORD CHANTIER</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

               
       
        <v-layout row   mt-2 ml-1 mb-3 >    
            <v-flex  sm2 mr-2 class="elevation-3">
                <v-card >
                    <v-toolbar   color="cyan" dark>
                        <v-toolbar-title >Informations Chantier</v-toolbar-title>
                    </v-toolbar>
                <v-list
                    two-line>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{detailChantier.libelle}}</v-list-tile-title>
                            <v-list-tile-sub-title>Libelle</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{detailChantier.chefProjet}}</v-list-tile-title>
                            <v-list-tile-sub-title>Responsable projet</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <span v-for="(item, index) in detailChantier.chefChantier" :key="index">
                            <v-chip outline text-color="green" label> {{ item }}</v-chip>/
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Chef chantier</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{detailChantier.dateD}} --{{detailChantier.dateF}} </v-list-tile-title>
                            <v-list-tile-sub-title>Période d'exécution</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{detailChantier.libEtat}}</v-list-tile-title>
                            <v-list-tile-sub-title>Etat</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>{{detailChantier.jourRestant}}</v-list-tile-title>
                            <v-list-tile-sub-title>Jour(s) restant(s)</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

                </v-card>
            </v-flex>

            <v-flex sm10 style="background-color: #FAFAFA" >
                <v-carousel  :cycle="false" light :hide-delimiters="true" class="pt-3 pr-3 pl-3 pb-3"  >
                    <v-carousel-item>
                        <WidgetTravaux :listeTrx="listeTravaux"></WidgetTravaux>
                    </v-carousel-item>
                     <v-carousel-item>
                        <WidgetChantier :chantier="detailChantier"> </WidgetChantier>
                    </v-carousel-item>
                </v-carousel>
            </v-flex>

        </v-layout>

        <!-- TAB CHANTIER -->
        <v-layout row >
             <v-flex sm12 ml-1 mr-1 mt-1>
                 <v-card  >
                 <el-tabs v-model="onglet" type="border-card" @tab-click="handleTabClick(onglet)" >
                    <el-tab-pane label="travaux">
                         <!-- RESULATS TRAVAUX -->
                         <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                        <ListeTravaux :type=1   :listeTrx= listeTravaux  @reloadListeTravaux="loadTravaux(detailChantier)"  > </ListeTravaux>
                         <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                      <br>
                   
                    </el-tab-pane>
                    <el-tab-pane label="Ouvriers/Prestataires" > 
                         <v-card tile>
                            <v-card-text>

                                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                                <ListePrestataire :idChantier=detailChantier.idChant :type=1  :listeOuvriers= listOuvriers   :listePrestataires= listPrestataires :show="showListeOuvrier" > </ListePrestataire>
                                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->

                            </v-card-text>
                        </v-card>
                    </el-tab-pane>

                    <el-tab-pane label="Reserve Travaux">
                         <!-- RESULATS RESERVE TRAVAUX -->
                        <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                        <ListeReserve :type=1   :listeReserveTrx= listeReserves  @reloadListeReserve="loadReserves()"  > </ListeReserve>
                         <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                      <br>
                   
                    </el-tab-pane>

                     <el-tab-pane label="Worklog">
                         <!-- RESULATS TRAVAUX -->
                         <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                        <ListeWorklog :type=2  :listeWorktrx = listworklogs :listeTacheWorktrx = listtache :idChantier = detailChantier.idChant  :totalHeuretrx = totalHeuretrx  :totalmintrx = totalmintrx :totalactivitetrx = totalActivite  @reloadWorklogs="loadWorklogs(detailChantier)"   ></ListeWorklog>
                         <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                      <br>
                   
                    </el-tab-pane>
                    
                </el-tabs>
                 </v-card>
            </v-flex>
        </v-layout>
         <!--FIN  TAB CHANTIER -->
            </v-card>
     </v-dialog>

              

    </div>
</template>

<script>

// import ContratOuvrier from '@/components/boardChantier/Contrat_ouvrier';

import ListeReserve from '@/components/rapport/ListeReserve';
import ListeTravaux from '@/components/boardTravaux/ListeTravaux';
import WidgetTravaux from '@/components/boardTravaux/widgetTravaux';
import WidgetChantier from '@/components/boardChantier/widgetChantier';
import ListePrestataire from '@/components/boardTravaux/ListePrestataire';
import ListeWorklog from '@/components/worklogs/ListeWorklog';
import Loading from '@/components/Loading'
export default {
    components:{ Loading,ListeReserve,ListeTravaux,ListePrestataire,ListeWorklog,WidgetTravaux,WidgetChantier },
    name: "DashboardChantier",
         props: {
             show:{
                 type: Boolean
             } ,
             detailChantier: {
                 type: Object
             },
         },
        data() 
        {
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                dialogDashboardChantier: false,
                loading: false,
                onglet: "0",
                listeTravaux: [],
                

                //ONGLET TRAVAUX
                detailTravaux: {},
                dialogConfirmRefus: false,
                showRapport: false,
                showListeRapport: false,
                dialogListeRapport: false,
                listeRapports : [],

                //ONGLET OUVRIERS
                listPrestataires:[],
                listOuvriers:[],
                showListeOuvrier: false,



               //ONGLET WORKLOG
                listworklogs:[],
                listtache:[],
                totalHeuretrx:[],
                totalmintrx:[],
                totalActivite:[],

                //ONGLET RESERVE
                listeReserves: [],


               

            }
        },
        methods: {

       

              closeDialog(){
                  this.listOuvriers.splice(0);
                  this.listPrestataires.splice(0);
                this.$emit('close')
            },

        
            loadTravaux (chantier) {
                
            this.loading = true
            
              let url = this.domaine + 'travaux/chantiers/'+chantier.id
              this.$http.get(url).then(response => {
                  console.log("loadTravaux 1",response.body.travaux )
                  this.listeTravaux = response.body.travaux
                  this.loading = false;
              }, 
              error =>{
                  this.loading = false;
                  this.$message.error('Echec lors du chargement des travaux')
              })
           
          },

       

          //ONGLETS OUVRIERS/PRESTATAIRE
         
          loadOuvrier(idChantier) 
          {
            this.loading = true;
            let url = this.domaine + "ouvrier/chantier/" +idChantier;
            this.$http.get(url).then(
                response => {
                console.log("conttrat prestataires",response.body.prestataires);
                this.listOuvriers = response.body.ouvriers;
                this.listPrestataires = response.body.prestataires;
                this.loading = false;
                this.showListeOuvrier = true
                },
                error => {
                this.loading = false;
                this.$message.error("Echec lors du chargement des ouvriers");
                }
            );
        },

        //ONGLET RESERVE
         loadReserves(){
                this.loading = true
                let url = this.domaine + 'reserve/chantier/'+this.detailChantier.idChant
                this.$http.get(url).then(response => {
                    this.listeReserves = response.body.reserves
                    this.loading = false;
                }, 
                error =>{
                    this.loading = false;
                    this.$message.error('Echec lors du chargement des reserves')
                })
         },

          //ONGLET WORKLOG
         loadWorklogs(idChantier){
                this.loading = true
                let url = this.domaine + 'worklogs/chantier/'+idChantier
                this.$http.get(url).then(response => {
                     this.listworklogs = response.body.listeWorklog;

                     
                    // this.totalheure = response.body.totalheure

                     this.totalHeuretrx = response.body.totalheure;
                     this.totalmintrx = response.body.totalMinutes;
                    this.totalActivite = response.body.totalActivite
                     this.listtache = response.body.listTacheeWorklog;
                    this.loading = false;
                }, 
                error =>{
                    this.loading = false;
                    this.$message.error('Echec lors du chargement des worklogs')
                })
         },

          handleTabClick(tab){
              this.showListeOuvrier = false
              switch (tab) {
                  case "0":
                      
                      if(this.listeTravaux.length == 0){
                            this.loadTravaux(this.detailChantier);
                        }
                      
                      break;
                  case "1":
                      console.log("loosd ouvrier")
                      if(this.listOuvriers.length == 0 && this.listPrestataires.length == 0  ){
                          this.loadOuvrier(this.detailChantier.idChant)

                      }
                      break;
                  case "2":
                      
                      if(this.listeReserves.length == 0   ){
                          this.loadReserves();
                      }
                      break;

                    case "3":
                        
                         this.loadWorklogs(this.detailChantier.idChant);
                        // if(this.listworklogs.length == 0 ){
                        //     console.log("WORLOG APUI")
                        //     this.loadWorklogs(this.detailChantier.idChant);
                        // }
                        break;
            
              
                  default:
                      break;
              }
          }

        },

        watch: {
            show : function(newValue, oldvalue){
               
               this.dialogDashboardChantier= newValue;
                if(newValue == true){
                    this.onglet = "0";
                    this.loadTravaux(this.detailChantier)
                    
                }
            }
        }
    

    
}
</script>
<style >
 .list {
    height: auto !important;
    }
    .list__tile__sub-title {
        height: 300px;
    }
    .list__tile__title {
    height: 45px;
    }   
    .list__tile__content, .list__tile__action {
    height: 73%;
    }
    .carousel {
        height:560px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/boardChantier/dashboard_chantier.vue